
<template>
  <section id="Articles" class="Articles">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>مقالات مربوط به میکسر حمل بتن</h2>
        <p class="text-center">
          در این قسمت مقالاتی را برای شما فراهم کرده ایم تا مبحث تراک میکسر بتن
          را بشناسید و از آن ها مطابق نیاز خودتان بهره بگیرید.
        </p>
      </div>

      <div class="row" data-aos="fade-up" data-aos-delay="100">
        <div class="col-lg-4 mb-5 mb-lg-0">
          <ul class="nav nav-tabs flex-column">

            <li v-for="item in contentListByCategoryArticles" :key="item.id" class="nav-item">
              <a
                :class=" contentListByCategoryArticles[0].id==item.id ? 'nav-link active show' : ' nav-link tab-pane' "
                data-bs-toggle="tab"
                :data-bs-target="'#tab-'+item.id"
              >
                <h4> {{ item.title }}</h4>
                <p>
                 {{ item.summary }}
                </p>
              </a>
            </li>

          </ul>
        </div>
        <div class="col-lg-8">          
          <div class="tab-content">

            <div  v-for="item in contentListByCategoryArticles" :key="item.id" :class="contentListByCategoryArticles[0].id==item.id  ?'tab-pane active show' : 'tab-pane'" :id="'tab-'+item.id">
              <div v-html="item.des"></div>

              <!-- <a href=""> ادامه مطلب ...</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import { mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor.vue";
import Alerts from "@/components/Alerts";
import { dataGridMixin } from "@/components/dataGridMixin";
import Swal from "sweetalert2";

export default {
  components: {
    TextEditor,
    Alerts,
  },
  mixins: [dataGridMixin],
  computed: {
    ...mapGetters({
      contentListByCategoryArticles: "controlPanelX/contentListByCategoryArticles",
    }),
  },
  data() {
    return {};
  },
  watch: {
    currentUser() {
      if (this.currentUser != undefined) {
        this.loadData();
      }
    },
  },
  methods: {},
  async created() {
    await this.$store.dispatch(
      "controlPanelX/getContentListByCategoryTitle",
      "Articles"
    );
  },
  mounted() {},
};
</script>


<style>
p {
  line-height: 35px;
  font-size: 15px;
}
</style>